<div class="d-flex flex-column">
    <div class="d-flex align-items-center justify-content-end mt-2 w-100">
        <span class="title-text margin-rigth3">Total</span>
        <span class="title-text margin-rigth2">Disponible</span>
        <span class="title-text margin-rigth1">Utilizar</span>
    </div>
    <div *ngFor="let servicio of servicios" class="d-flex flex-row align-items-center justify-content-between mt-2">
        <span class="nombre-servicio">{{servicio.nombre}}</span>
        <div class="contenedores-servicios">
            <span>{{servicio.total}}</span>
        </div>
        <div class="contenedores-servicios">
            <span>{{servicio.disponible}}</span>
        </div>
        <div class="d-flex flex-row justify-content-center align-items-center">
            <i class="fa-solid fa-circle-minus fs-16px text-red"></i>
            <div class="contenedores-servicios">
                <span>0</span>
            </div>
            <i class="fa-solid fa-circle-plus fs-16px text-blue"></i>
        </div>
    </div>

    <button class="btn btn-primary w-100 mt-2">Canjear</button>
</div>